import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import LoginForm from '../../forms/LoginForm';
import NavLanguage from '../AppNav/NavLanguage';
import AppFooterComponent from '../AppFooter';
import { SET_MODAL } from '../../constants';
import { getBrandDetails, getLanguage } from '../../selectors/global';
import {
  iconDollar,
  iconGift,
  iconPercent,
  iconUser,
  logoSandos4u,
} from 'assets/img/public-auth';

import './style.css';

const BENEFITS = [
  {
    icon: iconPercent,
    title: 'Special rate',
    text: 'Save from your first booking with exclusive discounts.',
  },
  {
    icon: iconDollar,
    title: 'Earn coins',
    text: 'Receive Coins at the end of each stay.',
  },
  {
    icon: iconGift,
    title: 'Redeem and enjoy',
    text: 'Turn your Coins into stays, experiences and amazing rewards.',
  },
];

const ModalLoginComponent = ({ onHide, history }, context) => {
  const dispatch = useDispatch();
  const isVisible = useSelector((state) => !!(state.modals.showingUp && state.modals.showingUp.login));
  const brand = useSelector(getBrandDetails);
  const locale = useSelector(getLanguage);
  const loggedIn = Boolean(useSelector((state) => state.authentication.loggedIn));

  useEffect(() => {
    if (!isVisible) {
      return undefined;
    }
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isVisible]);

  const closeAndGo = (path) => (e) => {
    if (e) {
      e.preventDefault();
    }
    dispatch({ type: SET_MODAL, key: 'login', val: false });
    if (typeof onHide === 'function') {
      onHide();
    }
    history.push(path);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="login-page-overlay" role="dialog" aria-modal="true">
      <div className="login-page">
        <div className="login-page__split">
          <aside className="login-page__promo">
            <div className="login-page__promo-inner">
              <img src={logoSandos4u} alt="Sandos4u Rewards Program" className="login-page__logo" />
              <h2 className="login-page__promo-title">{context.t('Join Sandos4u')}</h2>
              <ul className="login-page__benefits">
                {BENEFITS.map((benefit) => (
                  <li key={benefit.title} className="login-page__benefit">
                    <span className="login-page__benefit-icon">
                      <img src={benefit.icon} alt="" />
                    </span>
                    <span>
                      <strong>{context.t(benefit.title)}</strong>
                      <span>{context.t(benefit.text)}</span>
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </aside>

          <section className="login-page__panel">
            <div className="login-page__lang">
              <NavLanguage variant="public" />
            </div>
            <div className="login-page__form-wrap">
              <h3 className="login-page__heading">
                <img src={iconUser} alt="" className="login-page__heading-icon" />
                {context.t('Sign in')}
              </h3>
              <p className="login-page__lead">
                {context.t('Enter your details to access your account.')}
              </p>
              <LoginForm onClose={onHide} />
              <p className="login-page__member-prompt">
                {context.t('Not a Sandos4u member yet?')}
              </p>
              <Link
                to="/register"
                className="login-page__register-btn"
                onClick={closeAndGo('/register')}
              >
                {context.t('Register now')}
              </Link>
              <Link
                to="/forgot-password"
                className="login-page__recover"
                onClick={closeAndGo('/forgot-password')}
              >
                {context.t('Recover password')}
              </Link>
            </div>
            {brand && (
              <div className="login-page__footer">
                <AppFooterComponent
                  brandDetails={brand}
                  lang={locale}
                  loggedIn={loggedIn}
                  history={history}
                />
              </div>
            )}
          </section>
        </div>
      </div>
    </div>
  );
};

ModalLoginComponent.propTypes = {
  onHide: PropTypes.func,
  history: PropTypes.object.isRequired,
};

ModalLoginComponent.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default withRouter(ModalLoginComponent);
